import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AuthRoute from './components/AuthRoute';
import Dashboard from './pages/Dashboard';
import CreateChatbot from './pages/CreateChatbot';
import ChatbotSettings from './pages/ChatbotSettings';
import ChatbotPreviewPage from './pages/ChatbotPreviewPage';
import UserProfile from './pages/UserProfile';
import SettingsPage from './pages/SettingsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AllChatbotsPage from './pages/AllChatbotsPage';
import SignInPage from './pages/SignInPage';
import SignUpPage from './pages/SignUpPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/signin" element={<SignInPage />} />
                    <Route path="/signup" element={<SignUpPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />

                    {/* Protected Routes */}
                    <Route path="/" element={<AuthRoute />}>
                        <Route index element={<Dashboard />} />
                        <Route path="chatbots" element={<AllChatbotsPage />} />
                        <Route path="create" element={<CreateChatbot />} />
                        <Route path="chatbot/:id" element={<ChatbotSettings />} />
                        <Route path="preview/:id" element={<ChatbotPreviewPage />} />
                        <Route path="profile" element={<UserProfile />} />
                        <Route path="settings" element={<SettingsPage />} />
                        <Route path="settings/:tab" element={<SettingsPage />} />
                        <Route path="analytics" element={<AnalyticsPage />} />
                    </Route>

                    {/* Redirect for unknown routes */}
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;